export default __webpack_public_path__ + "static/media/Inter-ExtraBold.3e71093b.woff2";